import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import {
  ConsoleSpanExporter,
  SimpleSpanProcessor,
  WebTracerProvider,
} from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { trace } from '@opentelemetry/api';
import { ZoneContextManager } from '@opentelemetry/context-zone';

const TRACER_NAME = 'asta-react-client';
const resource = resourceFromAttributes({
  [ATTR_SERVICE_NAME]: TRACER_NAME,
});

const env = process.env.ENV;
const consoleExporter = new SimpleSpanProcessor(new ConsoleSpanExporter());
const gcpExporter = new SimpleSpanProcessor(
  new OTLPTraceExporter({
    url: `${window.location.origin}/otel/v1/traces`,
    headers: {},
  }),
);

const shouldConsoleTraces =
  env === 'local' || env === 'development' || env === 'staging';
const spanProcessors = shouldConsoleTraces ? [consoleExporter] : [gcpExporter];

const tracerProvider = new WebTracerProvider({
  resource,
  spanProcessors,
});

tracerProvider.register({
  // ZoneContextManager supports asynchronous operations
  contextManager: new ZoneContextManager(),
});

trace.setGlobalTracerProvider(tracerProvider);

export function getTracer() {
  return tracerProvider.getTracer(TRACER_NAME);
}
